module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-700.9e2e000a.eot";